/**
 * CPF: só dígitos, com os dois dígitos verificadores conferidos.
 *
 * Os onze dígitos iguais passam no cálculo e não existem: a Receita não emite.
 */
export function cpfValido(input) {
    const d = input.replace(/\D+/g, '');
    if (d.length !== 11 || /^(\d)\1{10}$/.test(d))
        return null;
    const digito = (ate) => {
        let soma = 0;
        for (let i = 0; i < ate; i++)
            soma += Number(d[i]) * (ate + 1 - i);
        const resto = (soma * 10) % 11;
        return resto === 10 ? 0 : resto;
    };
    return digito(9) === Number(d[9]) && digito(10) === Number(d[10]) ? d : null;
}
//# sourceMappingURL=cpf.js.map